import { StringParam, withDefault } from 'use-query-params';
import {
  CustomStringParam,
  FilterType,
  SchemaFilterType,
  SortDir,
} from '@ui/src';

export const columns = [
  {
    name: 'id',
    label: '',
    hidden: true,
  },
  {
    name: 'fullNumber',
    label: 'No.',
    sortable: true,
  },
  {
    name: 'search',
    label: 'Description',
  },
];

export const defaultSorter = {
  sortProp: columns[1].name,
  sortDir: SortDir.ASC,
};

export const schema = {
  fullNumber: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  search: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  ids: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  sortProp: {
    value: withDefault(StringParam, defaultSorter.sortProp),
    type: SchemaFilterType.STRING,
  },
  sortDir: {
    value: withDefault(StringParam, defaultSorter.sortDir),
    type: SchemaFilterType.STRING,
  },
};

export const filtersSchema = [
  {
    name: 'fullNumber',
    type: FilterType.TEXT,
    placeholder: 'Search by number...',
  },
  {
    name: 'search',
    type: FilterType.TEXT,
    placeholder: 'Search by name...',
  },
];

export const columnsLabels = {
  fullNumber: 'No.',
  search: 'Description',
};
